module.exports = __webpack_public_path__ + "static/media/checkmark.d70ea0bd.svg";